import { Component, OnInit, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { MatRadioChange, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { FormGroup, FormControl, Validators, NgForm, FormArray, FormBuilder } from '@angular/forms';
import { DateOccurrenceType } from '../../model/date-occurrence-type.model';
import { AppDateAdapter, APP_DATE_FORMATS } from './date-adapter';
import { ptDateMask } from '@app/shared/utils';

@Component({
  selector: 'app-occurence-dates',
  templateUrl: './occurence-dates.component.html',
  styleUrls: ['./occurence-dates.component.css'],
  providers: [
    {
      provide: DateAdapter, useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})
export class OccurenceDatesComponent implements OnInit {

  SINGLE_DATE: string = 'única data';
  MULTIPLE_DATES: string = 'múltiplas datas'
  SELECTED_OPTION: string = '';
  dateOptions: string[] = [this.SINGLE_DATE, this.MULTIPLE_DATES];
  _typesSelectedList: any;
  _occurenceTypes: any;
  datesMap: Map<string, any> = new Map();
  indexMap: Map<string, any> = new Map();
  datesMapFinal: Map<string, any> = new Map();
  indexMapFinal: Map<string, any> = new Map();


  @Input()
  public selectedDates: Array<DateOccurrenceType>;

  @Input()
  set typesSelectedList(typesSelectedList: any) {
    this._typesSelectedList = typesSelectedList;
    this.typesSelectedListChange();
  }

  @Input()
  set occurenceTypes(occurenceTypes: any) {
    this._occurenceTypes = occurenceTypes;
  }

  @Input()
  public isVisualization: boolean;

  get typesSelectedList() {
    return this._typesSelectedList;
  }

  get occurenceTypes() {
    return this._occurenceTypes;
  }

  @Input('datesForm')
  public datesForm: FormGroup;

  @Input('ngForm')
  public ngForm: NgForm;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.manageSelectedTypes();
  }

  get listType() {
    return this.typesSelectedList[0];
  }

  get dateArray() {
    return this.datesForm.get('dateArray') as FormArray;
  }

  get dateArrayFinal() {
    return this.datesForm.get('dateArrayFinal') as FormArray;
  }

  get dateOption() {
    return this.datesForm.get('fRbDate').value as string;
  }

  getDatePickerLabel(index: number) {
    if (this.isVisualization) {
      return this.typesSelectedList[0].length > 1 ? this.typesSelectedList[0][index].name : '';
    } else if ( !this.isVisualization && this.dateOption === this.SINGLE_DATE ) {
      return '';
    } else {
      return  this.typesSelectedList[0][index].name;
    }
  }

  typesSelectedListChange() {
    if (this.datesForm) {
      this.refreshDateArray(this.dateOption);
      this.refreshDateArrayFinal(this.dateOption);
    }
  }

  dateOptionsChange(mrChange: MatRadioChange) {
    this.refreshDateArray(mrChange.value);
    this.refreshDateArrayFinal(mrChange.value);
  }

  addDate(typeId: string, index: any) {
    if (this.datesMap.has(typeId)) {
      this.dateArray.push(this.formBuilder.control({value: this.datesMap.get(typeId), disabled: this.isVisualization} ,[Validators.required, ptDateMask]))
      this.indexMap.set(index.toString(), typeId);
    } else {
      this.dateArray.push(this.formBuilder.control({value: '', disabled: this.isVisualization}, [Validators.required, ptDateMask]));
      this.indexMap.set(index.toString(), typeId);
    }
  }

  addDateFinal(typeId: string, index: any) {
    let required = [];

    if (Array.isArray(this.selectedDates) && this.selectedDates.length > 0) {
      required = [Validators.required, ptDateMask];
    }

    if (this.datesMapFinal.has(typeId)) {
      this.dateArrayFinal.push(this.formBuilder.control({value: this.datesMapFinal.get(typeId), disabled: this.isVisualization}, required));
      this.indexMapFinal.set(index.toString(), typeId);
    } else {
      this.dateArrayFinal.push(this.formBuilder.control({value: '', disabled: this.isVisualization}, required));
      this.indexMapFinal.set(index.toString(), typeId);
    }
  }

  saveDateValues() {
    if (this.datesForm.get('dateArray')) {
      if (this.typesSelectedList.length > 0 && this.typesSelectedList[0].length > 0) {
        for (const { item, index } of this.dateArray.controls.map((item, index) => ({ item, index }))) {
          let typeId: string = this.indexMap.get(index.toString());
          this.datesMap.set(typeId, item.value);
        }
      }
    } if (this.datesForm.get('dateArrayFinal')) {
      if (this.typesSelectedList.length > 0 && this.typesSelectedList[0].length > 0) {
        for (const { item, index } of this.dateArrayFinal.controls.map((item, index) => ({ item, index }))) {
          let typeId: string = this.indexMapFinal.get(index.toString());
          this.datesMapFinal.set(typeId, item.value);
        }
        this.indexMapFinal.clear();
      }
    }

  }

  refreshDateArray(dateOption: string) {
    const indexMapBackup = this.indexMap;

    this.saveDateValues();
    
    this.datesForm.removeControl('dateArray');
    this.datesForm.addControl('dateArray', this.formBuilder.array([]));

    if (this.typesSelectedList.length > 0) {
      if (dateOption === this.SINGLE_DATE  && !this.isVisualization) {
        if (this.typesSelectedList[0].length > 0) {
          this.addDate('-1', 0);
        }
      } else {
        for (const { item, index } of this.typesSelectedList[0].map((item, index) => ({ item, index }))) {
          this.addDate(item.id.toString(), index);
        }
      }
    }
  }

  refreshDateArrayFinal(dateOption: string) {
    this.saveDateValues();

    this.datesForm.removeControl('dateArrayFinal');
    this.datesForm.addControl('dateArrayFinal', this.formBuilder.array([]));

    if (this.typesSelectedList.length > 0) {
      if (dateOption === this.SINGLE_DATE && !this.isVisualization) {
        if (this.typesSelectedList[0].length > 0) {
          this.addDateFinal('-1', 0);
        }
      } else {
        for (const { item, index } of this.typesSelectedList[0].map((item, index) => ({ item, index }))) {
          this.addDateFinal(item.id.toString(), index);
        }
      }
    }
  }

  manageSelectedTypes(): void {
    if (Array.isArray(this.selectedDates) && this.selectedDates.length > 0) {
      // if (this.dateOption === this.SINGLE_DATE) {
      //   this.selectedDates.forEach((item, i) => {
      //     this.datesMap.set(i.toString(), new Date(item.suggestedDate.toString().split('-').join('/')));
      //     this.datesMapFinal.set(i.toString(), item.approvedDate ? new Date(item.approvedDate.toString().split('-').join('/')) : '');
      //   });
      // } else {
        this.selectedDates.forEach((item) => {
          if (item.suggestedDate) {
            this.datesMap.set(item.occurrenceType.id.toString(), new Date(item.suggestedDate.toString().split('-').join('/')));
          }
          if (item.approvedDate) {
            this.datesMapFinal.set(item.occurrenceType.id.toString(), item.approvedDate ? new Date(item.approvedDate.toString().split('-').join('/')) : '');
          }
        });
      // }
    }
  }
}
